import { ClientProfile } from '../types';

export const mockClientProfiles: ClientProfile[] = [
  {
    id: '1',
    name: 'Billy Thompson',
    avatar: 'https://storage.googleapis.com/kiprweb/assets/2.jpg',
    availability: 'available',
    guardianId: '1',
    age: 8,
    diagnosis: 'Autism Spectrum Disorder',
    style: 'Visual learner, responds well to structured activities',
    startDate: '2024-01-15',
    concerns: [
      'Difficulty with social interactions',
      'Limited verbal communication',
      'Repetitive behaviors during transitions',
    ],
    strengths: [
      'Strong visual processing skills',
      'Excellent memory for details',
      'Responds well to consistent routines',
    ],
    reinforcers: ['Stickers', 'Tablet time', 'Preferred snacks', 'Break time'],
    triggers: ['Loud noises', 'sudden changes', 'Crowded spaces'],
    currentTargets: [
      'Increase spontaneous requests',
      'Increase peer engagement',
      'Build coping tools for group settings',
    ],
    techniques: ['PECS', 'Token economy', 'Social stories', 'Visual schedules'],
  },
  {
    id: '2',
    name: 'Maya Rodriguez',
    avatar: 'https://storage.googleapis.com/kiprweb/assets/6.jpg',
    availability: 'coming_soon',
    guardianId: '2',
    age: 12,
    diagnosis: 'ADHD with Oppositional Defiant Disorder',
    style: 'Kinesthetic learner, responds to movement-based activities',
    startDate: '2024-02-03',
    concerns: [
      'Difficulty following multi-step instructions',
      'Frequent outbursts when frustrated',
      'Challenges with peer relationships',
      'Impulsive behavior in group settings',
    ],
    strengths: [
      'High energy and enthusiasm',
      'Creative problem-solving abilities',
      'Strong leadership potential',
      'Responds well to physical activities',
    ],
    reinforcers: ['Movement breaks', 'Choice time', 'Praise notes', 'Special responsibilities'],
    triggers: ['Long sitting periods', 'Criticism', 'Feeling rushed', 'Overstimulation'],
    currentTargets: [
      'Follow 3-step instructions independently',
      'Use coping strategies when frustrated',
      'Initiate positive peer interactions',
      'Wait for turn during group activities',
    ],
    techniques: ['Behavior contracts', 'Self-monitoring', 'Peer mediation', 'Movement breaks'],
  },
];